'use client';

import React, { useState } from 'react';
import Link from 'next/link';
import { BlogPost } from '@/types/blog';
import GlowingButton from '../shared/GlowingButton';
import ArticleCardAlt from '../blog/ArticleCardAlt';
// import { useAnimateOnScroll } from '@/lib/hooks/useIntersectionObserver';

// Placeholder untuk konten sebelum dimuat
const BlogPostPlaceholder = () => (
  <div className="w-full h-[180px] bg-neutral-800/20 rounded-xl backdrop-blur-sm border border-neutral-700/30 overflow-hidden">
    <div className="flex flex-col h-full p-6">
      <div className="h-6 w-32 bg-neutral-700/30 rounded mb-3"></div>
      <div className="h-8 w-3/4 bg-neutral-700/30 rounded mb-4"></div>
      <div className="h-4 w-full bg-neutral-700/30 rounded mb-2"></div>
      <div className="h-4 w-2/3 bg-neutral-700/30 rounded"></div>
    </div>
  </div>
);

interface LatestBlogPostsProps {
  posts: BlogPost[];
}

const LatestBlogPosts = ({ posts }: LatestBlogPostsProps) => {
  const [selectedCategory, setSelectedCategory] = useState<string | null>(null);

  // Comment animasi untuk elemen blog posts
  // const titleAnimation = useAnimateOnScroll('animate-fade', 'delay-300');
  // const subtitleAnimation = useAnimateOnScroll('animate-fade', 'delay-400');
  // const buttonAnimation = useAnimateOnScroll('animate-fade', 'delay-700');

  // Comment animasi untuk garis dekoratif
  // const topLineAnimation = useAnimateOnScroll('animate-fade', 'delay-400');
  // const bottomLineAnimation = useAnimateOnScroll('animate-fade', 'delay-600');
  // const leftLineAnimation = useAnimateOnScroll('animate-fade', 'delay-800');
  // const rightLineAnimation = useAnimateOnScroll('animate-fade', 'delay-1000');

  // Comment animasi untuk blur spots
  // const topRightBlurAnimation = useAnimateOnScroll('animate-fade', 'delay-300');
  // const bottomLeftBlurAnimation = useAnimateOnScroll(
  //   'animate-fade',
  //   'delay-500'
  // );

  // Fungsi untuk filter posts berdasarkan kategori
  const filteredPosts = selectedCategory
    ? posts.filter(
        (post) => post.category.toLowerCase() === selectedCategory.toLowerCase()
      )
    : posts;

  // Urutkan berdasarkan tanggal terbaru
  const sortedPosts = [...filteredPosts].sort(
    (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
  );

  return (
    <section className="w-full py-16 relative overflow-hidden latest-posts-section">
      {/* Comment Background dengan dekorasi */}
      {/* <div className="absolute inset-0 -z-10">
        <div
          className="absolute inset-0"
          style={{
            backgroundImage:
              'linear-gradient(0deg, rgba(16,185,129,0.05) 1px, transparent 1px)',
            backgroundSize: '100% 28px',
            opacity: 0.03,
          }}
        />

        <div
          ref={topLineAnimation.ref as React.RefObject<HTMLDivElement>}
          className={`absolute top-[15%] left-0 right-0 h-px ${topLineAnimation.animationClasses}`}
          style={{
            background:
              'linear-gradient(90deg, transparent 0%, rgba(16, 185, 129, 0.2) 50%, transparent 100%)',
          }}
        ></div>

        <div
          ref={bottomLineAnimation.ref as React.RefObject<HTMLDivElement>}
          className={`absolute bottom-[15%] left-0 right-0 h-px ${bottomLineAnimation.animationClasses}`}
          style={{
            background:
              'linear-gradient(90deg, transparent 0%, rgba(16, 185, 129, 0.2) 50%, transparent 100%)',
          }}
        ></div>

        <div
          ref={leftLineAnimation.ref as React.RefObject<HTMLDivElement>}
          className={`absolute top-[15%] bottom-[15%] left-[10%] w-px hidden md:block ${leftLineAnimation.animationClasses}`}
          style={{
            background:
              'linear-gradient(180deg, transparent 0%, rgba(16, 185, 129, 0.2) 50%, transparent 100%)',
          }}
        ></div>

        <div
          ref={rightLineAnimation.ref as React.RefObject<HTMLDivElement>}
          className={`absolute top-[15%] bottom-[15%] right-[10%] w-px hidden md:block ${rightLineAnimation.animationClasses}`}
          style={{
            background:
              'linear-gradient(180deg, transparent 0%, rgba(16, 185, 129, 0.2) 50%, transparent 100%)',
          }}
        ></div>

        <div
          ref={topRightBlurAnimation.ref as React.RefObject<HTMLDivElement>}
          className={`absolute -top-20 -right-20 w-96 h-96 rounded-full bg-emerald-500/10 blur-3xl ${topRightBlurAnimation.animationClasses}`}
          style={{ opacity: 0.15 }}
        ></div>

        <div
          ref={bottomLeftBlurAnimation.ref as React.RefObject<HTMLDivElement>}
          className={`absolute -bottom-20 -left-20 w-96 h-96 rounded-full bg-emerald-500/10 blur-3xl ${bottomLeftBlurAnimation.animationClasses}`}
          style={{ opacity: 0.15 }}
        ></div>
      </div> */}

      <div className="relative z-10">
        {/* Section Header - Clean & Minimal */}
        <div className="mb-12 max-w-2xl">
          <h1
            // ref={titleAnimation.ref as React.RefObject<HTMLHeadingElement>}
            // className={`text-4xl md:text-5xl font-bold mb-2 ${titleAnimation.animationClasses}`}
            className="mb-2 opacity-100"
          >
            <span className="gradient-text">Featured</span> Articles
          </h1>
          <p
            // ref={subtitleAnimation.ref as React.RefObject<HTMLParagraphElement>}
            // className={`text-neutral-400 text-sm md:text-base leading-relaxed ${subtitleAnimation.animationClasses}`}
            className="excerpt"
          >
            Research, Thought, and Opinion about Law, Technology, and
            Cryptocurrency.
          </p>
        </div>

        {/* Latest 3 posts */}
        <div className="space-y-16 md:space-y-6">
          {sortedPosts.slice(0, 3).map((post, index) => (
            <div
              key={post.slug}
              className="opacity-100"
              style={{ animationDelay: `${(index + 4) * 100}ms` }}
            >
              <ArticleCardAlt post={post} />
            </div>
          ))}
        </div>

        {/* Footer CTA */}
        <div
          // ref={buttonAnimation.ref as React.RefObject<HTMLDivElement>}
          // className={`mt-12 flex justify-center ${buttonAnimation.animationClasses}`}
          className="mt-12 flex justify-center opacity-100"
        >
          <GlowingButton href="/blog/" variant="small">
            More Articles
          </GlowingButton>
        </div>
      </div>
    </section>
  );
};

export default LatestBlogPosts;
